const SET_SOLAR_INPUTS_IS_OPEN = 'SET_SOLAR_INPUTS_IS_OPEN';
const SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE = 'SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE';

export {
    SET_SOLAR_INPUTS_IS_OPEN,
    SET_SOLAR_INPUTS_SOLAR_INPUTS_TOGGLE,
};



// WEBPACK FOOTER //
// ./src/containers/Inputs/SolarInputs/constants.js